<section class="nrc-how">
  <div class="nrc-how__centered">
    <h2 class="nrc-how__heading">How we calculate your roof's costs</h2>
    <div class="nrc-how__row">
      @for (item of steps; track item.title; let i = $index) {
        <div class="nrc-how__col">
          @if (i === 0) {
            <div
              class="nrc-how__card nrc-how__card--clickable"
              role="button"
              tabindex="0"
              (click)="onStep1CardClick()"
              (keydown.enter)="onStep1CardClick()"
              (keydown.space)="onStep1Keydown($event)"
            >
              <picture class="nrc-how__pic" [style.background-color]="item.color">
                <img [src]="'assets/images/' + item.icon" alt="" aria-hidden="true" />
              </picture>
              <h4>{{ item.title }}</h4>
              <p>{{ item.description }}</p>
            </div>
          } @else {
            <div class="nrc-how__card">
              <picture class="nrc-how__pic" [style.background-color]="item.color">
                <img [src]="'assets/images/' + item.icon" alt="" aria-hidden="true" />
              </picture>
              <h4>{{ item.title }}</h4>
              <p>{{ item.description }}</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
</section>
